<template>
  <el-drawer
    :visible.sync="drawer"
    :title="title"
    :class="['drawer', direction === 'btt' && 'bbt-rrawer']"
    :append-to-body="true"
    :with-header="withHeader"
    :size="size"
    :modal="true"
    close-on-click-modal
    :destroy-on-close="destroyOnClose"
    :before-close="handleClose"
    :direction="direction"
    :close-on-press-escape="false"
  >
    <!-- <template v-if="customTitle" #header>
      <slot name="header"></slot>
    </template> -->
    <div v-if="customTitle" slot="title">
      <slot name="title"></slot>
    </div>
    <slot v-else name="title"></slot>
    <!-- <template v-if="!customTitle">
      <slot name="title"></slot>
    </template> -->
    <div class="drawer-content">
      <slot></slot>
    </div>
    <div v-if="isShowFooter" slot="footer">
      <slot name="footer"></slot>
    </div>
    <slot v-else name="footer"></slot>
    <!-- <template v-if="isShowFooter" #footer>
      <slot name="footer"></slot>
    </template> -->
  </el-drawer>
</template>

<script>
// import { defineProps, defineEmits } from "vue";
export default {
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    size: {
      type: [Number, String],
      default: 600
    },
    title: {
      type: String,
      default: 'title'
    },
    withHeader: {
      type: Boolean,
      default: true
    },
    customTitle: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'btt'
    },
    destroyOnClose: {
      type: Boolean,
      default: true
    },
    isShowFooter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.drawer-content {
  width: 100%;
  height: 100%;
  position: relative;
  background: #ffffff;
  .close {
    position: absolute;
    left: -20px;
    z-index: 1;
    top: 50%;
    margin-top: -64px;
    width: 32px;
    height: 108px;
    background: #ffffff;
    box-shadow: -4px 0px 6px 1px rgba(0, 0, 0, 0.08);
    writing-mode: vertical-lr;
    font-size: 14px;
    font-weight: 400;
    color: #b8c3de;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
    &::before {
      content: "";
      width: 0;
      height: 0;
      top: -10px;
      position: absolute;
      border-bottom: 10px solid transparent;
      border-top: 10px solid transparent;
      border-right: 32px solid #ffffff;
    }
    &::after {
      content: "";
      width: 0;
      height: 0;
      top: 99px;
      position: absolute;
      border-bottom: 10px solid transparent;
      border-top: 10px solid transparent;
      border-right: 32px solid #ffffff;
    }
  }
}
</style>
<style>
.bbt-rrawer {
  border-radius: 6px 6px 0px 0px;
}
</style>
